import { DirectionRight, NormalUser } from "@/Icons";
import { ResourceCodeEnums } from "@/api/dmp_common/interface";
import {
  querySubAccountAuthMallList,
  querySubAccountList,
} from "@/api/sub_account";
import { CarouselNoticebar, Tag, Toast } from "@ad/anq-ui";
import GlobalContext from "models/globalContext";
import React, { useContext, useEffect, useState } from "react";
import ModalMallAuth from "views/menu_layout/sub_account_management/modal_mall_auth";
import {
  AuthMallStatusEnums,
  AuthMallListItem,
  SubAccountListItem,
} from "src/api/sub_account/interface";
import EllipsisText from "components/ellipsis_text";

const AccountInfo = () => {
  const {
    name,
    userPicUrl,
    mallId,
    mallOwner,
    username,
    uid,
    mallOwnerUsername,
  } = useContext(GlobalContext);

  const [modalMallAuthVisible, setModalMallAuthVisible] = useState(false);

  const [mallList, setMallList] = useState<AuthMallListItem[]>([]);
  const [subAccountList, setSubAccountList] = useState<SubAccountListItem[]>(
    []
  );

  useEffect(() => {
    if (uid) {
      getMallList();
    }
    if (mallOwner) {
      getSubAccountList();
    }
  }, [uid]);

  const getMallList = async () => {
    const res = await querySubAccountAuthMallList({ uid });

    if (res?.success) {
      setMallList(res.result.authMallList);
    } else {
      Toast.error(res?.errorMsg || "查询授权店铺失败");
    }
  };

  const getSubAccountList = async () => {
    const res = await querySubAccountList();

    if (res?.success) {
      setSubAccountList(res.result.subAccountList);
    } else {
      Toast.error(res?.errorMsg || "查询子账号失败");
    }
  };

  const mallAuthLength = mallList.filter(
    (item) => item.status === AuthMallStatusEnums.HAS_AUTH
  ).length;

  return (
    <div className="ml-4 w-[360px] rounded-lg bg-white p-6">
      <div className="flex items-center gap-4">
        <div className="h-[56px] w-[56px] shrink-0 overflow-hidden rounded-[50%] border border-[#DFE0E6]">
          {userPicUrl ? (
            <img src={userPicUrl} alt="" className="h-full w-full" />
          ) : (
            <div className="flex h-full w-full items-center justify-center">
              <NormalUser className="text-[20px]" />
            </div>
          )}
        </div>
        <div>
          <div className="mb-2">
            {mallOwner && <Tag text="主账号" className="mr-1" size="small" />}
            <span className="text-base font-semibold">{name}</span>
          </div>
          <div className="mb-[2px] text-sm text-text-black/[.5]">{`店铺 ID：${mallId}`}</div>
          <div className="text-sm text-text-black/[.5]">{`账号名：${username}`}</div>
        </div>
      </div>

      <div className="my-6 h-[1px] w-full bg-[rgb(235,236,242)]"></div>

      <div className="flex gap-6 text-text-black-base">
        <div className="w-0 flex-1">
          <div className="mb-3">店铺权限</div>
          <div
            className="dmp-link flex cursor-pointer items-center"
            onClick={() =>
              mallAuthLength ? setModalMallAuthVisible(true) : undefined
            }
          >
            <span className="text-base font-semibold">
              {mallAuthLength || "-"}
            </span>
            {mallAuthLength ? (
              <DirectionRight className="ml-1 text-[16px]" />
            ) : null}
          </div>
        </div>
        <div className="mb-3 w-0 flex-1">
          <div className="mb-3">{mallOwner ? "主账号" : "子账号"}</div>
          {mallOwner ? (
            <div
              className="dmp-link flex cursor-pointer items-center"
              onClick={() => {
                window.open(
                  `/${ResourceCodeEnums.ACCOUNT_MANAGEMENT}?menu=${ResourceCodeEnums.SUB_ACCOUNT_MANAGEMENT}`
                );
              }}
            >
              <span className="text-base font-semibold">
                {subAccountList.length}
              </span>
              <DirectionRight className="ml-1 text-[16px]" />
            </div>
          ) : (
            <div>
              <EllipsisText>
                <span className="text-base font-semibold">
                  {mallOwnerUsername}
                </span>
              </EllipsisText>
            </div>
          )}
        </div>
      </div>
      {!mallAuthLength && (
        <CarouselNoticebar
          withArrow={true}
          type="warn"
          content={
            mallOwner ? (
              <span>
                请
                <a
                  href="https://dmp.pinduoduo.com/account_management?menu=account_auth"
                  className="dmp-link text-text-blue"
                >
                  点击配置
                </a>
                店铺授权
              </span>
            ) : (
              "请联系「主账号」或招商小二配置店铺权限"
            )
          }
          closable={false}
        />
      )}
      <ModalMallAuth
        visible={modalMallAuthVisible}
        onClose={() => setModalMallAuthVisible(false)}
        record={{ uid, mallOwner }}
        onManageMall={() => {
          window.open(
            `/${ResourceCodeEnums.ACCOUNT_MANAGEMENT}?menu=${ResourceCodeEnums.ACCOUNT_AUTH}`
          );
        }}
      />
    </div>
  );
};

export default AccountInfo;
